import Model from '@/lib/data/Model';

const $t = function (v) {
    return window.app.$t.call(window.app, v);
};

class RoleFunction extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'module_name',
        'function_name',
        {
            name: 'valid_access_code',
            type: 'int',
            defaultValue: 0,
        },
        {
            name: 'access_code',
            type: 'int',
            defaultValue: 0,
        },
    ];

    get moduleNameDisplay() {
        switch (this.module_name) {
            case 'agent_management':
                return $t('Risk Engineer Management');
            case 'survey_management':
                return $t('Survey Management');
            case 'customer_management':
                return $t('Client Management');
            case 'video_call':
                return $t('Video Call');
            case 'form_management':
                return $t('Form Management');
            case 'role_management':
                return $t('Role Management');
            case 'reports':
                return $t('Reports');
            case 'organization_management':
                return $t('Organizations');
            case 'demo_visits':
                return $t('Demo Inspections');
            case 'claim_management':
                return $t('Claim Management');
            case 'damage_notice':
                return $t('Damage Notice');
            default:
                return this.module_name;
        }
    }

    get functionNameDisplay() {
        switch (this.function_name) {
            case 'survey_management_feeds':
                return $t('Survey Management');
            case 'survey_management_inspection':
                return $t('Inspections');
            case 'survey_management_inspection_report':
                return $t('Inspection Reports');
            case 'customer_management_customer':
                return $t('Clients');
            case 'customer_management_micro_list':
                return $t('Micro List');
            case 'assign_demo_visits':
                return $t('Inspections');
            case 'form_management_form':
                return $t('Forms');
            case 'organization_management_user':
                return $t('Users');
            case 'organization_management_organization':
                return $t('Organization');
            case 'reports_general':
                return $t('All Reports');
            case 'org_admin_reports':
                return $t('Org. Reports');
            case 'role_management_role':
                return $t('Roles');
            case 'survey_management_dashboard':
                return $t('Dashboard');
            case 'video_call_history':
                return $t('History');
            case 'video_call_send_email':
                return $t('Send Email');
            case 'video_call_send_sms':
                return $t('Send SMS');
            case 'video_call_send_link':
                return $t('Send Link');
            case 'video_call_customer':
                return $t('Clients');
            case 'appointment_self':
                return $t('My Appointments');
            case 'appointment_others':
                return $t('Other Appointments');
            case 'video_call_agent':
                return $t('Risk Engineers');
            case 'video_call_direct':
                return $t('Direct Call');
            case 'agent_management_agent':
                return $t('Risk Engineers');
            case 'claim_management':
                return $t('Claim Management');
            default:
                return this.function_name;
        }
    }

    get enabled() {
        return this.access_code == 1;
    }

    get view() {
        return (1 & this.access_code) == 1 ? 1 : 0; //eslint-disable-line
    }

    set view(v) {
        this.accessCodeSetter(1, v);
    }

    get add() {
        return (2 & this.access_code) == 2 ? 2 : 0;//eslint-disable-line
    }

    set add(v) {
        this.accessCodeSetter(2, v);
    }

    get edit() {
        return (4 & this.access_code) == 4 ? 4 : 0;//eslint-disable-line
    }

    set edit(v) {
        this.accessCodeSetter(4, v);
    }

    get delete() {
        return (8 & this.access_code) == 8 ? 8 : 0;//eslint-disable-line
    }

    set delete(v) {
        this.accessCodeSetter(8, v);
    }

    get export() {
        return (16 & this.access_code) == 16 ? 16 : 0;//eslint-disable-line
    }

    set export(v) {
        this.accessCodeSetter(16, v);
    }

    accessCodeSetter(code, value) {
        if (value === 0) {
            if ((code & this.access_code) == code) {//eslint-disable-line
                this.access_code -= code;
            }
        } else if (value === code && (code & this.access_code) != code) {//eslint-disable-line
            this.access_code += code;
        }
    }

    constructor(data) {
        super(data);
        this.init();
    }

    api = [];
}

export default RoleFunction;
